import React from "react";
import { GlobalStore } from "../../store/global/GlobalStore";
import multiply from "../../img/trade-interface/multiply.svg";
import { ExchangeRate } from "./ExchangeRate";
import { ReactComponent as InfoIcon } from "../../img/trade-interface/info.svg";
import { isManyToOne, isOneToMany, isOneToOne } from "../../utils/quoteUtils";
import { Token } from "../../store/global/TokenEnum";
import { Amount } from "../../types/amount";
import { Tooltip } from "components/general/Tooltip";

export interface Rate {
  from: Token;
  to: Token;
  price: Amount;
  flippedPrice: Amount;
}

export const RatesRow: React.FC = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const quote = GlobalStore.useState(s => s.quote);
  const exchangeRateText =
    "Exchange rates used for this trade. Rates reflect current market prices.";
  const getExchangeRates = (): Array<Rate> => {
    if (quote) {
      if (isOneToOne(quote)) {
        return [
          {
            from: Object.keys(quote.makerTokens)[0] as Token,
            to: Object.keys(quote.takerTokens)[0] as Token,
            price: Object.values(quote.takerTokens)[0].priceBeforeFee ?? Amount.ZERO,
            flippedPrice: Object.values(quote.makerTokens)[0].priceBeforeFee ?? Amount.ZERO,
          },
        ];
      } else if (isOneToMany(quote)) {
        const makerTokens = Object.entries(quote.makerTokens);
        const takerToken = Object.keys(quote.takerTokens)[0] as Token;
        return makerTokens.map(([key, value]) => {
          const makerTokenRate = value.priceBeforeFee ?? Amount.ZERO;
          const flippedPrice: Amount = makerTokenRate.value.gt(0)
            ? new Amount("1").div(makerTokenRate)
            : Amount.ZERO;
          return {
            from: takerToken,
            to: key as Token,
            price: makerTokenRate,
            flippedPrice: flippedPrice,
          };
        });
      }
      if (isManyToOne(quote)) {
        const takerTokens = Object.entries(quote.takerTokens);
        const makerToken = Object.keys(quote.makerTokens)[0] as Token;
        const rates = takerTokens.map(([key, value]) => {
          const rate = value.priceBeforeFee ?? Amount.ZERO;
          return {
            from: key as Token,
            to: makerToken,
            price: new Amount("1").div(rate),
            flippedPrice: rate,
          };
        });
        return rates;
      }
    }

    return [];
  };
  const exchangeRates = getExchangeRates();

  return (
    <>
      <hr className="dashed my-1" />
      {exchangeRates.map((rate, i) => (
        <span key={i}>
          <div
            className={`d-flex ${i === 0 ? "justify-content-between" : "justify-content-end"}`}
            data-testid="rates-row"
          >
            {i === 0 && (
              <div className="d-flex align-items-center text-secondary">
                <div className={`d-flex`} style={{ color: theme.font.secondary.default }}>
                  <img src={multiply} className="me-2" alt={"Exchange rate"} />
                  <div className="d-flex align-items-center">
                    Guaranteed Rate{exchangeRates.length > 1 ? "s" : ""}
                    <Tooltip title={exchangeRateText}>
                      <InfoIcon className="ms-2 d-none d-sm-block" width={12} height={12} />{" "}
                    </Tooltip>
                  </div>
                </div>
              </div>
            )}
            <div className="d-flex flex-column align-items-end">
              <ExchangeRate
                symbol={rate.from}
                oppositeSymbol={rate.to}
                price={rate.price}
                flippedPrice={rate.flippedPrice}
              />
            </div>
          </div>
        </span>
      ))}
    </>
  );
};
